import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue";
const _hoisted_1 = ["aria-label", "aria-expanded"];
const _hoisted_2 = {
  class: "app-nav__avatar",
  "aria-hidden": "true"
};
const _hoisted_3 = {
  key: 1,
  class: "app-nav__avatar-fallback"
};
const _hoisted_4 = {
  class: "app-mobile-more-shell"
};
const _hoisted_5 = {
  class: "app-mobile-more"
};
const _hoisted_6 = {
  class: "app-mobile-more__copyright"
};
const _hoisted_7 = ["aria-label", "aria-expanded"];
const _hoisted_8 = {
  class: "app-nav__avatar",
  "aria-hidden": "true"
};
const _hoisted_9 = {
  key: 1,
  class: "app-nav__avatar-fallback"
};
import { ref, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { ArrowDown } from '@element-plus/icons-vue';
import AppImage from '@/components/common/AppImage.vue';
import EditProfileDialog from '@/components/EditProfileDialog.vue';
import AppNavUserMenuPanel from '@/components/nav/AppNavUserMenuPanel.vue';
import { Z_INDEX } from '@/config/zIndex';
import { resolveMediaUrl } from '@/utils/resolve-media-url';
export default {
  __name: 'AppNavUserMenu',
  props: {
    profile: {
      type: Object,
      default: null
    },
    profileLoading: {
      type: Boolean,
      default: false
    },
    /** H5：头像旁挂账户 Drawer */
    mobileDrawer: {
      type: Boolean,
      default: false
    },
    /** H5 Drawer 内展示可用余额 */
    balanceLabel: {
      type: String,
      default: ''
    },
    /**
     * H5 头像点击是否打开本组件账户 Drawer。
     * false 时改为 emit avatar-click（交给外层打开「更多」抽屉）。
     */
    openDrawerOnAvatarClick: {
      type: Boolean,
      default: true
    },
    /** H5 账户 Drawer 开关（可由底栏「我的」控制） */
    open: {
      type: Boolean,
      default: false
    },
    loggingOut: {
      type: Boolean,
      default: false
    }
  },
  emits: ['logout', 'switch-locale', 'profile-updated', 'avatar-click', 'update:open'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const {
      locale
    } = useI18n();
    const router = useRouter();
    const copyrightYear = new Date().getFullYear();
    const menuPlacement = computed(() => locale.value === 'ar' ? 'bottom-start' : 'bottom-end');
    const settingsOpen = ref(false);
    const avatarFailed = ref(false);
    const internalOpen = ref(false);
    const open = computed({
      get: () => props.mobileDrawer ? props.open : internalOpen.value,
      set: value => {
        if (props.mobileDrawer) {
          emit('update:open', value);
          return;
        }
        internalOpen.value = value;
      }
    });
    const displayName = computed(() => {
      const api = props.profile;
      return api?.nickName || api?.username || api?.email || 'User';
    });
    const avatarUrl = computed(() => resolveMediaUrl(String(props.profile?.avatar ?? '').trim()));
    watch(avatarUrl, () => {
      avatarFailed.value = false;
    });
    const avatarInitial = computed(() => {
      if (props.profileLoading) return '…';
      const name = String(displayName.value || '').trim();
      if (!name || name === 'User') return '?';
      const parts = name.split(/\s+/).filter(Boolean);
      if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
      return name.slice(0, 2).toUpperCase();
    });
    function onAvatarClick() {
      if (props.mobileDrawer && !props.openDrawerOnAvatarClick) {
        emit('avatar-click');
        return;
      }
      open.value = true;
    }
    function go(path) {
      open.value = false;
      router.push(path);
    }
    function goAccountTab(tab) {
      open.value = false;
      router.push({
        name: 'Account',
        query: {
          tab
        }
      });
    }
    function openSettings() {
      open.value = false;
      settingsOpen.value = true;
    }
    function onProfileSaved() {
      emit('profile-updated');
    }
    function onLogout() {
      if (props.loggingOut) return;
      emit('logout');
    }
    function onSwitchLocale(code) {
      emit('switch-locale', code);
    }
    return (_ctx, _cache) => {
      const _component_el_drawer = _resolveComponent("el-drawer");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_popover = _resolveComponent("el-popover");
      return _openBlock(), _createElementBlock(_Fragment, null, [__props.mobileDrawer ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("button", {
        type: "button",
        class: "app-nav__avatar-trigger app-nav__avatar-trigger--h5",
        "aria-label": displayName.value,
        "aria-expanded": open.value,
        onClick: onAvatarClick
      }, [_createElementVNode("span", _hoisted_2, [avatarUrl.value && !avatarFailed.value ? (_openBlock(), _createBlock(AppImage, {
        key: 0,
        src: avatarUrl.value,
        alt: "",
        class: "app-nav__avatar-img",
        eager: "",
        onError: _cache[0] || (_cache[0] = $event => avatarFailed.value = true)
      }, null, 8, ["src"])) : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(avatarInitial.value), 1))])], 8, _hoisted_1), __props.openDrawerOnAvatarClick ? (_openBlock(), _createBlock(_component_el_drawer, {
        key: 0,
        modelValue: open.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => open.value = $event),
        direction: "ltr",
        size: "min(320px, 88vw)",
        "show-close": true,
        title: _ctx.$t('nav.account'),
        class: "app-nav-user-drawer app-mobile-more-drawer",
        "append-to-body": "",
        "z-index": _unref(Z_INDEX).MOBILE_NAV_DRAWER,
        onClosed: _cache[3] || (_cache[3] = $event => open.value = false)
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(AppNavUserMenuPanel, {
          "h5-layout": "",
          "hide-locale-picker": "",
          profile: __props.profile,
          "profile-loading": __props.profileLoading,
          "balance-label": __props.balanceLabel,
          "logging-out": __props.loggingOut,
          onClose: _cache[1] || (_cache[1] = $event => open.value = false),
          onNavigate: go,
          onAccountTab: goAccountTab,
          onOpenSettings: openSettings,
          onLogout: onLogout
        }, null, 8, ["profile", "profile-loading", "balance-label", "logging-out"])]), _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('siteFooter.copyright', {
          year: _unref(copyrightYear)
        })), 1)])]),
        _: 1
      }, 8, ["modelValue", "title", "z-index"])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createBlock(_component_el_popover, {
        key: 1,
        visible: open.value,
        "onUpdate:visible": _cache[6] || (_cache[6] = $event => open.value = $event),
        placement: menuPlacement.value,
        width: 280,
        trigger: "click",
        "show-arrow": false,
        "popper-class": "app-nav-menu-popper"
      }, {
        reference: _withCtx(() => [_createElementVNode("button", {
          type: "button",
          class: "app-nav__avatar-trigger",
          "aria-label": displayName.value,
          "aria-expanded": open.value
        }, [_createElementVNode("span", _hoisted_8, [avatarUrl.value && !avatarFailed.value ? (_openBlock(), _createBlock(AppImage, {
          key: 0,
          src: avatarUrl.value,
          alt: "",
          class: "app-nav__avatar-img",
          eager: "",
          onError: _cache[4] || (_cache[4] = $event => avatarFailed.value = true)
        }, null, 8, ["src"])) : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(avatarInitial.value), 1))]), _createVNode(_component_el_icon, {
          class: "app-nav__avatar-chevron",
          "aria-hidden": "true"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ArrowDown))]),
          _: 1
        })], 8, _hoisted_7)]),
        default: _withCtx(() => [_createVNode(AppNavUserMenuPanel, {
          profile: __props.profile,
          "profile-loading": __props.profileLoading,
          "logging-out": __props.loggingOut,
          onClose: _cache[5] || (_cache[5] = $event => open.value = false),
          onNavigate: go,
          onAccountTab: goAccountTab,
          onOpenSettings: openSettings,
          onLogout: onLogout,
          onSwitchLocale: onSwitchLocale
        }, null, 8, ["profile", "profile-loading", "logging-out"])]),
        _: 1
      }, 8, ["visible", "placement"])), _createVNode(EditProfileDialog, {
        modelValue: settingsOpen.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => settingsOpen.value = $event),
        profile: __props.profile,
        onSaved: onProfileSaved
      }, null, 8, ["modelValue", "profile"])], 64);
    };
  }
};